const userObj = {
    email: null,
    type: null,
    name: null,
    password:null,
    phone:"",
    avatar:null,
    restaurant:{
        name:null,
        country:null,
        logo:null
    },
    locations:[],
    work_area: [],
    work_area_role:[],
}
export const state = {
        user: JSON.parse(JSON.stringify(userObj)),
        //   ...userObj
    }
   
    export const actions = {
        getuser({commit}){
            this._vm.$axios.get('/me')
            .then(response => {
                let user = response.data.payload.user;
                if(user.phone == null)
                    user.phone = ""
                   commit('updateUser',user)              
            });
            
        },

        resetState({commit}) {
            commit('updateUser',JSON.parse(JSON.stringify(userObj)));
         },
    }

  export const mutations= {
        updateUser(state, new_val) {
            state.user = new_val
        },
    }

    // export const getters= {
    //     user(state) {
    //         return state.user;
    //     }
    // }
    export const getters = {
        userGetter: state => state.user
      };




